//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export const PROMOTED_POSTS_AUDIENCE_ACTIONS = {
  CLEAR_PROMOTED_POSTS_AUDIENCE_STATE: 'CLEAR_PROMOTED_POSTS_AUDIENCE_STATE',
  REQUEST_ACCOUNT_AUDIENCES: 'REQUEST_ACCOUNT_AUDIENCES',
  RECEIVE_ACCOUNT_AUDIENCES: 'RECEIVE_ACCOUNT_AUDIENCES',
  UPDATE_SELECTED_AUDIENCE: 'UPDATE_SELECTED_AUDIENCE',
  UPDATE_LOOKALIKE_AUDIENCE: 'UPDATE_LOOKALIKE_AUDIENCE',
  UPDATE_CUSTOM_AUDIENCE_LOCATION: 'UPDATE_CUSTOM_AUDIENCE_LOCATION',
  UPDATE_CUSTOM_AUDIENCE_AVAILABLE_LOCATIONS: 'UPDATE_CUSTOM_AUDIENCE_AVAILABLE_LOCATIONS',
  UPDATE_CUSTOM_AUDIENCE_AGE: 'UPDATE_CUSTOM_AUDIENCE_AGE',
  UPDATE_CUSTOM_AUDIENCE_GENDERS: 'UPDATE_CUSTOM_AUDIENCE_GENDERS',
};

export enum PromotedPostsAudienceTypes {
    LOOKALIKE = 'PromotedPostAutomatic',
    CUSTOM = 'PromotedPostCustom',
}

export enum PromotedPostsGenders {
    MALE = 'male',
    FEMALE = 'female',
}
